/**
 * ローカルストレージで使用するキー名を定義
 */

// 時間モード
export const LocalStorageKeys = {
    // 時間パネル
    TIME_COUNTDOWN_STATE: 'time_countdown_state',
    TIME_DISPLAY_FONT: 'time_display_font',
    // 進捗パネル
    PROGRESS_PANEL_MODE: 'progress_panel_mode',
    // アクティビティカレンダーパネル
    ACTIVITY_CALENDAR_INFO: 'activity_calendar_info',
    // 検索で利用する色項目の並び順
    COLOR_ORDER: 'color_order',
    // シンプル分析パネル：期間タイプ
    SIMPLE_ANALYTICS_PERIOD: 'simple_analytics_period',
};
